import { NavbarProps, Option } from "./types/navbarProps";
import './navbar.scss';
import { AdditionalIcon } from "../additionalIcon/additionalIcon";

const Navbar = (props: NavbarProps) => {
    var iconStylization: React.CSSProperties = {
        display: 'inline-block',
        verticalAlign: 'middle'
    }

    const liCreate = (name?: string) => {
        return (<span className={`${props.itemClassName} body-txt-medium`} style={{ width: props.spanView ? '0px' : '110px' }}>{name}</span>)
    }

    const options = () => {
        return props.options?.map((option: Option, index: number) => {
            var iconStyle = option.additionalIconStyle ? option.additionalIconStyle : iconStylization;
            return (option.disabled
                ? <li key={index + 1} className={props.selected === index + 1 ? 'menu-nav-disabled active' : 'menu-nav-disabled'} tabIndex={index + 1}>
                    {!option.iconAtTheEnd ? AdditionalIcon(option.additionalIcon, iconStyle) : ''}
                    {liCreate(option.name)}
                    {option.iconAtTheEnd ? AdditionalIcon(option.additionalIcon, iconStyle) : ''}
                </li>
                : <li key={index + 1} className={props.selected === index + 1 ? 'active' : undefined} tabIndex={index + 1} onClick={option.onClick}>
                    {!option.iconAtTheEnd ? AdditionalIcon(option.additionalIcon, iconStyle) : ''}
                    {liCreate(option.name)}
                    {option.iconAtTheEnd ? AdditionalIcon(option.additionalIcon, iconStyle) : ''}
                </li>
            )
        })
    }

    return (
        <ul ref={props.ref} className={props.className ? props.className : `${props.addClass} menu-nav${props.rolledOut ? ' show-menu' : ''}`} style={props.style}>
            {options()}
        </ul>
    )
}

export default Navbar;